package uz.ferro.erp.feature.user.model

import kotlinx.serialization.Serializable

@Serializable
data class User(
    val id: Long? = null,
    val username: String? = null,
    val password: String? = null,
    val firstName: String? = null,
    val lastName: String? = null,
    val patronymic: String? = null,
    val role: Role? = null,
    val disabled: Boolean? = null
) {

    fun fullName(): String {
        return "${lastName.orEmpty()} ${firstName.orEmpty()} ${patronymic.orEmpty()}".trim()
    }
}